import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import HospitalFulfillmentRateChart from "./HospitalFulfillmentRateChart";

// Static data for hospital fulfillment rate by region
const STATIC_FULFILLMENT_DATA = {
  regions: ["Central", "West", "East", "North", "South"],
  rates: [92, 88, 85, 78, 82],
};

const HospitalFulfillmentRateWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Hospital Fulfillment Rate by Region")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <HospitalFulfillmentRateChart data={STATIC_FULFILLMENT_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default HospitalFulfillmentRateWrapper;
